import * as CookieConsent from 'vanilla-cookieconsent';

const updateGtmConsent = (cookie) => {
    if (typeof window.gtag === 'function') {
        window.gtag('consent', 'update', {
            'analytics_storage': cookie.categories.includes('analytics') ? 'granted' : 'denied',
            'ad_storage': cookie.categories.includes('marketing') ? 'granted' : 'denied',
            'ad_user_data': cookie.categories.includes('marketing') ? 'granted' : 'denied',
            'ad_personalization': cookie.categories.includes('marketing') ? 'granted' : 'denied',
        });
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'cookie_consent_update'
    });
};

const startCookieConsent = async () => {
    const locale = document.documentElement.getAttribute('lang') || 'en';
    const translations = JSON.parse(document.getElementById('cookie-consent').innerText);

    return CookieConsent.run({
        guiOptions: {
            consentModal: {
                layout: "box",
                position: "bottom right",
                equalWeightButtons: true,
                flipButtons: false
            },
            preferencesModal: {
                layout: "box",
                position: "right",
                equalWeightButtons: true,
                flipButtons: false
            }
        },
        onFirstConsent: ({ cookie }) => updateGtmConsent(cookie),
        onChange: ({ cookie }) => updateGtmConsent(cookie),
        onModalShow() {
            document.querySelectorAll('#cc-main button[data-role="all"]').forEach($el => {
                $el.classList.add('btn-primary');
            });
        },
        categories: {
            necessary: {
                readOnly: true
            },
            functionality: {},
            analytics: {},
            marketing: {}
        },
        language: {
            default: locale,
            autoDetect: "document",
            translations: {
                [locale]: translations
            }
        }
    });
};

document.addEventListener('DOMContentLoaded', startCookieConsent);

document.addEventListener('livewire:navigated', async () => {
    CookieConsent.reset();
    await startCookieConsent();
});
